import type { JSX } from "react/jsx-runtime"
const SvgComponent = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={112}
    height={90}
    fill="none"
    {...props}
  >
    <path
      fill="red"
      fillRule="evenodd"
      d="M55.833 0c4.774 0 9.67.123 14.416.324l5.606.268 5.366.318 5.025.34 4.59.358a21.23 21.23 0 0 1 19.507 19.112l.224 2.373.418 5.08c.391 5.266.682 11.005.682 16.494 0 5.488-.291 11.228-.682 16.493l-.418 5.08c-.073.816-.145 1.603-.224 2.374A21.226 21.226 0 0 1 90.83 87.725l-4.579.352-5.025.346-5.37.319-5.606.267a343.75 343.75 0 0 1-14.417.324 343.75 343.75 0 0 1-14.416-.323l-5.605-.269-5.366-.318-5.025-.346-4.59-.352A21.228 21.228 0 0 1 1.323 68.614L1.1 66.24.68 61.16A227.028 227.028 0 0 1 0 44.667c0-5.489.29-11.228.681-16.494l.419-5.08c.073-.816.145-1.603.223-2.373A21.228 21.228 0 0 1 20.826 1.608l4.584-.357 5.025-.34 5.37-.32 5.607-.267C46.216.115 51.024.007 55.833 0ZM44.667 31.127v27.08c0 2.579 2.791 4.187 5.025 2.903l23.45-13.54a3.35 3.35 0 0 0 0-5.807L49.692 28.23a3.35 3.35 0 0 0-5.025 2.904v-.006Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgComponent
